import React from 'react';
import { formatBaht } from '../../lib/price.js';
import { pickLocalized, tFor } from '../../i18n/i18n.js';

// Live-updating price breakdown. `lines` is an array of { label, amount }
// items; the last line (or any with .isTotal) is rendered bold + with the
// top border. The widget renders this between the form and the action
// bar so the customer always sees what they're about to be charged.

export function PriceSummary({ lines, locale }) {
  const t = tFor(locale);
  return (
    <div className="sp-summary" aria-label={t('pay.total')}>
      {lines.map((line, i) => {
        const cls = [
          'sp-summary__row',
          line.isTotal && 'is-total',
        ].filter(Boolean).join(' ');
        return (
          <div key={`${line.label}-${i}`} className={cls}>
            <span>{line.label}</span>
            <span className="sp-summary__amount">
              {formatBaht(line.amount)}
            </span>
          </div>
        );
      })}
    </div>
  );
}

// Helper to compute the lines for a given booking draft.
export const buildSummaryLines = ({
  service,
  extrasQuantities,
  extrasIndex,
  locale,
}) => {
  if (!service) return [];
  const t = tFor(locale);
  const lines = [];
  lines.push({
    label: pickLocalized(service.translations, locale),
    amount: service.price,
  });
  for (const extraId of Object.keys(extrasQuantities)) {
    const qty = extrasQuantities[extraId];
    if (!qty) continue;
    const extra = extrasIndex[extraId];
    if (!extra) continue;
    lines.push({
      label: pickLocalized(extra.translations, locale),
      amount: extra.price * qty,
    });
  }
  const total = lines.reduce((sum, l) => sum + l.amount, 0);
  lines.push({ label: t('pay.total'), amount: total, isTotal: true });
  return lines;
};
